import { OrderManager } from './OrderManager'
import { buildIssueStoreLoader, SEEDS_ISSUE_ORDER } from './SpecialIssue'

export const getSeedsOrder = buildIssueStoreLoader(
  SEEDS_ISSUE_ORDER,
  OrderManager,
)
export type { OrderManager }
